export function findKeyInObj(obj: object, key: string): any {
  if (!key || !key.split) {
    return null;
  }
  return key.split(".").reduce((acc, cv) => {
    if (acc !== null && typeof acc !== "undefined") {
      return acc[cv];
    }
    return null;
  }, obj);
}

export type EmptyObject = Record<string, never>;
